import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

function PaymentsPage() {
    const { reference } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [orderData, setOrderData] = useState(null);
    const [paymentTriggered, setPaymentTriggered] = useState(false);
    // const reference = 'Pl7W5I4a8oykRQudzYLS'


    // Fetch order data and setup OnePay
    useEffect(() => {
        if (!reference) {
            setError('Invalid payment reference');
            setLoading(false);
            return;
        }

        const fetchOrderData = async () => {
            try {
                setLoading(true);
                const response = await axios.get(
                    // `http://localhost:19878/api/user/courses/payment/${reference}`
                    `https://api.helpinghandlk.com/api/user/courses/payment/${reference}`
                );

                console.log("API Response:", response);

                if (response.data.success) {
                    const formData = response.data.data;
                    setOrderData(formData);

                    // Parse price - handle various formats
                    const priceString = formData.coursePrice?.toString() || '0';
                    const parsedPrice = parseFloat(priceString.replace(/[^0-9.]/g, ""));

                    if (isNaN(parsedPrice) || parsedPrice <= 0) {
                        throw new Error('Invalid price amount');
                    }

                    // Split full name safely
                    const nameParts = (formData.fullName || '').trim().split(/\s+/);
                    const firstName = nameParts[0] || 'Customer';
                    const lastName = nameParts.slice(1).join(' ') || '';

                    // Validate phone number
                    const phone = formData.phone || '';
                    if (!phone.startsWith('+')) {
                        console.warn('Phone number should start with country code (+94 for Sri Lanka)');
                    }

                    // OnePay Data configuration
                    const onePayData = {
                        appid: "80NR1189D04CD635D8ACD",
                        hashToken: "GR2P1189D04CD635D8AFD",
                        amount: parsedPrice,
                        orderReference: reference,
                        customerFirstName: firstName,
                        customerLastName: lastName,
                        customerPhoneNumber: phone,
                        customerEmail: formData.email,
                        transactionRedirectUrl: `${window.location.origin}/payment/success`,
                        additionalData: formData.courseName,
                        currency: 'LKR',
                        apptoken: "ca00d67bf74d77b01fa26dc6780d7ff9522d8f82d30ff813d4c605f2662cea9ad332054cc66aff68.EYAW1189D04CD635D8B20"
                    };

                    console.log('OnePay Configuration:', onePayData);
                    window.onePayData = onePayData;

                } else {
                    throw new Error(response.data.message || 'Failed to fetch order details');
                }
            } catch (err) {
                console.error('Error fetching order data:', err);
                setError(
                    err.response?.data?.message ||
                    err.message ||
                    'Failed to load payment details'
                );
            } finally {
                setLoading(false);
            }
        };

        fetchOrderData();
    }, [reference]);

    // Setup payment event listeners
    useEffect(() => {
        const handlePaymentSuccess = async (e) => {
            console.log("Payment SUCCESS:", e.detail);

            try {
                const response = await axios.post(
                    // `http://localhost:19878/api/user/courses/payment/${reference}/update`,
                    `https://api.helpinghandlk.com/api/user/courses/payment/${reference}/update`,
                    {
                        status: e.detail?.status || 'SUCCESS',
                        transaction_id: e.detail?.transaction_id,
                        code: e.detail?.code
                    }
                );

                console.log('Status update response:', response.data);

                // Redirect to success page
                    navigate(`/payment/success?ref=${reference}&txn=${e.detail?.transaction_id}`);

            } catch (err) {
                console.error('Error updating payment status:', err);
                // alert('Payment successful but failed to update order. Please contact support.');
            }
        };

        const handlePaymentFail = async (e) => {
            console.log("Payment FAIL:", e.detail);

            try {
                await axios.post(
                    `https://api.helpinghandlk.com/api/user/courses/payment/${reference}/update`,
                    {
                        status: 'FAILED',
                        transaction_id: e.detail?.transaction_id || null,
                        code: e.detail?.code
                    }
                );

                // Redirect to failure page
                    navigate(`/payment/failed?ref=${reference}`);

            } catch (err) {
                console.error('Error updating payment status:', err);
            }
        };

        window.addEventListener("onePaySuccess", handlePaymentSuccess);
        window.addEventListener("onePayFail", handlePaymentFail);

        return () => {
            window.removeEventListener("onePaySuccess", handlePaymentSuccess);
            window.removeEventListener("onePayFail", handlePaymentFail);
        };
    }, [reference, navigate]);

    // Auto-trigger payment button when script is loaded
    useEffect(() => {
        if (orderData && !loading && !paymentTriggered) {
            setPaymentTriggered(true);
            if (window.onPayButtonClicked) {
                console.log('Triggering OnePay payment...');
                window.onPayButtonClicked();
            }

        }
    }, [orderData, loading, paymentTriggered]);


    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4">
            <div className="max-w-2xl mx-auto">
                <div className="bg-white rounded-lg shadow-xl p-8">
                    <h1 className="text-3xl font-bold text-gray-800 mb-2 text-center">
                        Complete Payment
                    </h1>
                    <p className="text-gray-600 text-center mb-6">
                        Please wait while we redirect you to the payment gateway
                    </p>

                    <div className="text-center mb-4">
                        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                    </div>

                    <div style={{ margin: "20px" }}>
                        <div id="onepay-btn" style={{ display: 'none' }} />
                        <div id="iframe-container" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentsPage